import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseDivider } from 'app/components/common/BaseDivider'
import { BaseModal } from 'app/components/common/BaseModal'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { ModalComponent } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputPassword } from 'app/components/common/inputs/InputPassword'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { BaseTableWrapper } from 'app/components/tables/BaseTableReport/styles'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { FONT_SIZE, FONT_WEIGHT } from 'parkway-web-common'
import styled from 'styled-components'

export const ButtonCreateAction = styled(BaseButton)`
  background-color: var(--states-orange-color);
  color: var(--background-color);
  transition: all 0.5s ease;
  &.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: var(--background-color);
    color: var(--states-orange-color);
    border-color: var(--states-orange-color);
    transition: all 0.5s ease;
  }
`
export const LabelWrapper = styled(BaseRow)`
  color: var(--main-2-color);
`

export const RequireDot = styled.div`
  color: var(--states-red-color);
`
export const DashLine = styled(BaseDivider)``

export const TitleForm = styled.div`
  color: var(--primary-color);
  font-size: ${FONT_SIZE.md};
  font-weight: ${FONT_WEIGHT.bold};
`
export const ButtonModal = styled(BaseButton)`
  color: var(--primary-color) !important;
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.medium} !important;
  border: 1px solid #e1e7ea;
  border-radius: 8px;
  padding: 4px 12px;
  opacity: 0.8 !important;
  cursor: pointer;
`

export const FormItem = styled(BaseForm.Item)``

export const FormInput = styled(BaseInput)``

export const FormInputPassword = styled(InputPassword)``

export const SelectBaseStyled = styled(BaseSelect)``

export const ButtonSkillAction = styled(BaseButton)`
  border-color: transparent;
  transition: all 0.5s ease;
  color: var(--primary-color) !important;
  box-shadow: none;
  border: 1px solid #e1e7ea;
  font-size: ${FONT_SIZE.xxs} !important;
  font-weight: ${FONT_WEIGHT.medium} !important;
  opacity: 0.8;
  padding: 4px 8px;

  &:hover {
    background-color: var(--other-blue-color);
    color: var(--background-color) !important;
    transition: all 0.5s ease;
    border-color: transparent !important;
    box-shadow: none;
  }
`
export const ModalWrapper = styled(ModalComponent)`
  background: red;
`
export const BaseTableReport = styled(BaseTableWrapper)`
  .ant-table-thead > tr > th {
    text-align: left !important;
    font-size: ${FONT_SIZE.xxs} !important;
    font-weight: ${FONT_WEIGHT.semibold} !important;
    color: ${convertedVariables.primaryColor};
    opacity: 0.7;
  }
  .ant-table-thead > tr > th:last-child {
    text-align: right !important;
  }
`
export const ClassificationWrapper = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;

  & span {
    font-size: ${FONT_SIZE.xxs};
    color: var(--text-primary2-color);
  }

  .tag {
    background-color: #f8f8f8;
    border-radius: 100px;
    padding: 2px 1rem;
    font-size: ${FONT_SIZE.xs};
    font-weight: ${FONT_WEIGHT.semibold};
  }

  .excellent {
    background-color: #fffbed;
    color: #fa9f34;
  }

  .good {
    background-color: #ecfdf2;
    color: #28ba59;
  }

  .average_good {
    background-color: #e8f6f9;
    color: #629daa;
  }

  .average {
    background-color: #e8f6f9;
    color: #629daa;
  }

  .below_average {
    background-color: #e8f6f9;
    color: #629daa;
  }

  .weak {
    background-color: #ffe6e6;
    color: #ff7373;
  }
`
export const Option = styled(BaseRow)`
  background-color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding 8px 0px !important;
`
export const OptionText = styled(BaseText)`
  font-size: 14px;
  color: var(--text-primary2-color);
  margin-left: 8px;
  width: 135px;
`
export const ButtonContainer = styled.div`
  cursor: pointer;
  border: 1px solid #e1e7ea;
  border-radius: 8px;
  padding: 4px;
  display: flex;
`
export const JobTitleText = styled(BaseText)`
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.semibold} !important;
  color: ${convertedVariables.primaryColor};
  opacity: 0.9;
`
export const ExpiredDate = styled(BaseText)`
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.regular} !important;
  color: ${convertedVariables.primaryColor};
  opacity: 0.9;
`
export const UnitText = styled(BaseText)`
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.semibold} !important;
  color: var(--text-primary2-color);
  margin-left: 8px;
  opacity: 0.7;
`
export const TitleText = styled(BaseText)`
  font-size: 16px !important;
  font-weight: ${FONT_WEIGHT.semibold} !important;
  color: ${convertedVariables.primaryColor};
  padding: 20px;
`

export const ContentContainer = styled(BaseSpace)`
  padding: 20px;
  border-top: 1px solid #ebeef2;
`
export const JobTitleCol = styled(BaseSpace)``
export const BorderCol = styled(BaseCol)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  margin-top: 5px;
`
export const PromotionModal = styled(BaseModal)`
  .ant-modal-content {
    padding: 0 !important;
  }
`
export const Dot = styled.div<{ color?: string }>`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: ${props => props?.color};
  margin-top: 3px;
`
export const VerticalDivider = styled.div<{ color?: string }>`
  width: 1px;
  height: 100%;
  border-right: 1px dashed ${props => props?.color};
  margin-top: 16px;
`
export const UnitContainer = styled(BaseSpace)`
  gap: 10px !important;
  margin-left: 20px;
`
